import {Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';
import * as _ from 'lodash';
import { CoreService } from 'src/app/services';
import { CoreDatahubService } from 'src/app/services';
import {FlatCategoryRecursive} from '../../business/media/DTO/recursive-category.dto';
import {debounce, debounceTime, delay, exhaustMap, map, mapTo} from 'rxjs/operators';
import {CategorySearchResponseDto} from './category-search-response.dto';
import {fromEvent} from 'rxjs';
import {isArray} from 'util';
import {NzModalService} from 'ng-zorro-antd';
import {ProductAddQuickComponent} from '../../business/products/product-add-quick/product-add-quick.component';
import {ModalCategoryComponent} from './modal-category/modal-category.component';
import {environment} from '../../../environments/environment';

let that;

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent implements OnInit {
  constructor(
    private coreService: CoreService,
    private coreDatahubService: CoreDatahubService,
    public modalService: NzModalService,
  ) {
    that = this;
  }

  options: any = [];
  optionsLevel1: any = [];
  allItem: any = [];
  categories;
  category;
  value = '';
  id;
  valueTmpCategory = [];
  @Input() categoryStr: string;
  @Input() categoryValue: any;
  @Output() valueChange = new EventEmitter();
  @Input() categoriesParent;
  ngOnInit() {

    this.value = this.categoriesParent.map(z => z.name).join(' -> ');
  }

  openModal() {
    console.log( this.categoriesParent);
    console.log( this.valueTmpCategory);
    const modal = this.modalService.create({
      nzTitle : 'Chọn danh mục sản phẩm',
      nzContent: ModalCategoryComponent,
      nzWidth: '1300px',
      nzFooter: null,
      nzComponentParams: {
        apiSearch: environment.apiSearch,
        apiDetail: environment.apiDetail,
        categoriesParent: this.valueTmpCategory && this.valueTmpCategory.length > 0 ? this.valueTmpCategory :  this.categoriesParent
      },
      nzBodyStyle: {
        background: '#F4F6F8'
      }
    });
    modal.afterClose.subscribe( z => {

      if(z){
        const lstCategoryIdHighLight = modal.getContentComponent().lstCategoryIdHighLight;
        this.valueTmpCategory = lstCategoryIdHighLight;
        const name = lstCategoryIdHighLight[lstCategoryIdHighLight.length - 1].name;
        this.valueChange.emit(lstCategoryIdHighLight.map(q =>  q.id));
        this.value = name.includes('->') ? name :  lstCategoryIdHighLight.map( q => q.name).join(' -> ');
      }

    });
  }
}
